module.exports = __webpack_public_path__ + "img/404-bg.3bb692c9.svg";